import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Icons } from '../icons/icons';

// TODO refactor

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const DraggableTableRow = ({ row, onDelete, onUpdate, onExport, onInspect }: any): JSX.Element => {
  const {
    attributes,
    listeners,
    transform,
    transition,
    setNodeRef,
    isDragging
  } = useSortable({
    id: row.original.id
  });
  const style = {
    transform: CSS.Transform.toString(transform),
    transition: transition,
  };
  return (
    <tr ref={setNodeRef} style={style} {...row.getRowProps?.()} className="table-row">
      {isDragging ? (
        <td colSpan={row.cells.length} className="body-cell">&nbsp;</td>
      ) : (
        row.cells.map((cell: any, index: number) => {
          if (index === 0) {
            return (
              <td {...cell.getCellProps()} className="body-cell">
                <Icons.Drag {...attributes} {...listeners} />
                <span>{cell.render('Cell')}</span>
              </td>
            );
          }

          return (
            <td {...cell.getCellProps()} className="body-cell">
              {cell.render('Cell')}
            </td>
          );
        })
      )}
      {(typeof onDelete === 'function' || typeof onUpdate === 'function' || typeof onExport === 'function' || typeof onInspect === 'function') && (
        <td role="cell" className="body-cell row-action-cell">
          {typeof onExport === 'function' && (
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            <span onClick={(): void => onExport?.(row.original)}>
              <Icons.Export className="pointer row-action" />
            </span>
          )}
          {typeof onInspect === 'function' && (
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            <span onClick={(): void => onInspect?.(row.original)}>
              <Icons.Inspect className="pointer row-action" />
            </span>
          )}
          {typeof onUpdate === 'function' && (
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            <span onClick={(): void => onUpdate?.(row.original)}>
              <Icons.Edit className="pointer row-action" />
            </span>
          )}
          {typeof onDelete === 'function' && (
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            <span onClick={(): void => onDelete?.(row.original)}>
              <Icons.Delete className="pointer row-action" />
            </span>
          )}
        </td>
      )}
    </tr>
  );
};
